// Loading.js
import React from 'react';
import './Loading.css';

const Loading = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

export default Loading;
